import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Paper, Typography, withStyles } from '@material-ui/core';
import {
    getOwnerStripeData,
    getOwnerSelectedPropertyId,
    getOwnerReservations,
} from '../../stores/dashboard/selectors';
import styles from './styles';

const OwnerDashboardCards = (props) => {
    const reservationData = useSelector(getOwnerReservations);
    const stripeData = useSelector(getOwnerStripeData);
    const selectedPropertyId = useSelector(getOwnerSelectedPropertyId);

    let dataTotals = {};
    let dataStripe = {};

    if (!selectedPropertyId || selectedPropertyId === 'all') {
        dataTotals = reservationData.totals || [];
        dataStripe = stripeData || [];
    } else {
        dataTotals = reservationData?.properties[selectedPropertyId] || {};
        dataStripe = stripeData?.properties[selectedPropertyId] || {};
    }

    const grossBookings =
        (dataTotals.stripe || 0) +
        (dataTotals.fuel_comp || 0) +
        (dataTotals.cash || 0);

    const cards = [
        { title: 'Income', value: `$${dataStripe?.revenue || 0}` },
        { title: 'Gross Bookings', value: grossBookings },
        { title: 'Stripe Payments', value: dataTotals.stripe || 0 },
        { title: 'In-Store Cash Sales', value: dataTotals?.cash || 0 },
        { title: 'Fuel Comps', value: dataTotals.fuel_comp || 0 },
    ];

    return (
        <Grid
            container
            spacing={0}
            alignItems="stretch"
            className={props.classes.dashboardCardsGridContainerStyle}
        >
            {cards.map((card) => (
                <Grid
                    item
                    key={card.title}
                    className={props.classes.dashboardCardsGridItemStyle}
                >
                    <Paper className={props.classes.cardStyle}>
                        <Typography className={props.classes.cardHeaderStyle}>
                            {card.title}
                        </Typography>
                        <Typography className={props.classes.valueStyle}>
                            {card.value}
                        </Typography>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

export default withStyles(styles)(OwnerDashboardCards);
